import { Typography } from '@mui/material';
import { TournamentPlayerStatus } from '@okletsplay/core';
import CheckIcon from '@mui/icons-material/Check';
import React, { FC, ReactElement, useMemo } from 'react';

interface TournamentTeamPlayerStatusProps {
  status: TournamentPlayerStatus;
}

export const TournamentTeamPlayerStatus: FC<TournamentTeamPlayerStatusProps> = ({ status }) => {
  const statusTemplates = useMemo<
    Partial<Record<TournamentPlayerStatus, ReactElement | null>>
  >(() => {
    return {
      [TournamentPlayerStatus.Ready]: <CheckIcon color="success" />,
      [TournamentPlayerStatus.Standby]: null,
      [TournamentPlayerStatus.Declined]: null,
      [TournamentPlayerStatus.Played]: null,
      [TournamentPlayerStatus.Disqualified]: null,
      [TournamentPlayerStatus.Invited]: <Typography color="text.secondary">Invited</Typography>,
    };
  }, []);

  if (!status) {
    return null;
  }

  return <>{statusTemplates[status]}</>;
};
